const lego = window.lego
const GOOGLE_MAPS_JS_SRC = `https://maps.googleapis.com/maps/api/js?v=3.36&key=${lego.config.GOOGLE_MAPS_KEY}`

let loadInitiated = false

let mapsPromiseResolve
let mapsPromiseReject
const mapsPromise = new Promise((resolve, reject) => {
  mapsPromiseResolve = resolve
  mapsPromiseReject = reject
})

function loadScript() {
  loadInitiated = true

  const script = document.createElement('script')

  script.src = GOOGLE_MAPS_JS_SRC
  script.onload = () => mapsPromiseResolve(window.google.maps)
  script.onerror = mapsPromiseReject

  document.head.appendChild(script)
}

export default function getGoogleMapsApi() {
  if (!loadInitiated) loadScript()

  return mapsPromise
}
